var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"block"},[_c('p',{staticClass:"text-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"text-content"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }